import axios from 'axios';
import { stats } from '@fiverr-private/obs';

// Client-side AJAX metrics, mirroring seller_plus_sphinx `programs_kit` trackRequestMetrics
// (inlined here so we don't take a dependency on that package).
// Emits, under `<PROJECT>.ajax.<name>`:
//   count  .success / .error
//   time   .success_time / .error_time.<status>   (statsd timer → .mean/.upper_90/.mean_90/.count/…)
const PROJECT = 'careers_page_perseus';

export async function trackRequestMetrics<T>(promise: Promise<T>, name: string): Promise<T> {
    const startedAt = new Date();

    try {
        const data = await promise;
        stats.count(PROJECT, `ajax.${name}.success`);
        stats.time(PROJECT, `ajax.${name}.success_time`, startedAt);
        return data;
    } catch (error) {
        const status = axios.isAxiosError(error) ? error.response?.status ?? 'unknown' : 'unknown';
        stats.count(PROJECT, `ajax.${name}.error`);
        stats.time(PROJECT, `ajax.${name}.error_time.${status}`, startedAt);
        throw error;
    }
}
